"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.join");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = orderMultiprice;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Order field generation helper.
 *
 * Signature: `orderMultiprice(options, fieldName, [valueFieldName,] currency)`
 *
 * @param {Object} [options]
 * @param {string} [options.prefix='__order__']
 * @param {Function} [options.partsBuilder] Function that gets fieldName, valueFieldName and currency and returns
 *     assembled string.
 * @param {Function} [options.assembler] Function that joins prefix and parts.
 * @param {string} fieldName
 * @param {string} [valueFieldName]
 * @param {string} currency
 *
 * @returns {string} String in format `${prefix}${fieldName}_[${valueFieldName}_]${currency}`
 */
function orderMultiprice(options, fieldName, valueFieldName, currency) {
  var _prefix$partsBuilder$ = (0, _extends2.default)({
    prefix: '__order__',
    partsBuilder: function partsBuilder(fn, vfn, crr) {
      return [fn, vfn, crr].filter(Boolean).join('_');
    },
    assembler: function assembler(prfx, parts) {
      return "".concat(prfx).concat(parts);
    }
  }, options),
      assembler = _prefix$partsBuilder$.assembler,
      partsBuilder = _prefix$partsBuilder$.partsBuilder,
      prefix = _prefix$partsBuilder$.prefix;

  return assembler(prefix, partsBuilder(fieldName, valueFieldName, currency));
}